// Styles for LegalTextWithLink go here.
import styled from 'styled-components';

export const StyledLegalTextWithLink = styled.div`
  .legal-text-link {
    margin: 2rem 0;
  }
`;
